module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-fr-acb382bd.webp";